/**
 * 明细
 */
import React from 'react';
import { Modal, Slider, Alert } from 'antd';
import { connect } from 'react-redux';
import { XSelect, XOKButton, XCancelButton, XInput } from '@/components/xqxc_ui';
import PropTypes from 'prop-types';
import styles from './ActivityDate.module.scss';
import ActivityDateTable from '../components/ActivityDateTable';
import model from '@/reducers/market/cardcentre/model';
import http from '@/assets/api/http';
import { message } from 'antd';

class ActivityDate extends React.Component {

    state = {
        title: this.props.title,
        visible: this.props.visible,
        confirmLoading: false,
        person: '',//会员账号
        type: {},//类型
        pageNum: 1,
        pageSize: 10,
        taskId: this.props.data.id,//卡券中心id
    }

    componentDidMount() {
        const { getCardcentreListState, } = this.props;
        getCardcentreListState();
        this._searchHandle();
    }

    componentWillUnmount() {//清除数据渲染
        for (const key in this.props.receiveDetail) {
            delete this.props.receiveDetail[key];
        }
    }

    _handleOk = () => {
        this.setState({
            visible: false,
        });
        this.props.closeMode();
    }

    _handleCancel = () => {
        this.setState({
            visible: false,
        });
        this.props.closeMode();
    }

    _tableAction = (record, type) => {
        const { history, } = this.props;
        if (type == 'expendOrderId') {
            history.push({
                pathname: `/home/order/distributionorder/orderdetail/${record.expendOrderId}`,
            });

        }
    }

    // 页面发生变化
    _paginationChange = (pageSize, pageNum) => {
        const { person, type } = this.state;
        this.searchCache = {
            ...this.searchCache,
            tel: person,//会员账号  	  
            couponUsableType: type.code,//状态  
            pageNum,
            pageSize,
        };
        this.setState({
            pageSize, pageNum
        });
        this.props.getCardcentreListDetail(this.searchCache);
    }

    // 查询触发  
    _searchHandle = () => {
        const { person, type, pageNum, pageSize, taskId } = this.state;
        this.searchCache = {
            couponId: taskId, //代言任务id
            tel: person,//会员账号  	  
            couponUsableType: type.code,//状态  
            pageNum,
            pageSize,
        };
        this.props.getCardcentreListDetail(this.searchCache);
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({ type: {}, person: '' }, () => {
            const { type, person } = this.state;
            this.searchCache = { ...this.searchCache, couponUsableType: type.code, tel: person, };
        });
    }

    render() {
        const { visible, title, confirmLoading, person, type, } = this.state;
        const { data, cardcentreListDetail, cardcentreListState } = this.props;

        return (
            <Modal
                width={960}
                centered
                title={title}
                visible={visible}
                confirmLoading={confirmLoading}
                onCancel={this._handleCancel}
                onOk={this._handleOk}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                footer={null}
            >
                <div className={styles.container}>
                    <div className={`${styles.layout} ${styles.dataTop}`}>
                        <div className={`${styles.layout}`}>
                            <div><h4>已领取：</h4><span>{data.receiveNum}</span></div>
                            <div><h4>已使用：</h4><span>{data.usedNum}</span></div>
                            <div><h4>已过期：</h4><span>{data.expiredNum}</span></div>
                        </div>
                    </div>

                    <div className={styles.search_box}>
                        <XInput
                            inputStyle={{ width: '150px' }}
                            label='会员账号'
                            placeholder='请输入'
                            value={person}
                            bindThis={this}
                            bindName='person'
                        />
                        <XSelect
                            selectStyle={{ width: '150px' }}
                            label='类型'
                            placeholder='请选择'
                            renderData={cardcentreListState}
                            dataIndex='value'
                            keyIndex='code'
                            value={type.value}
                            bindThis={this}
                            bindName='type'
                            showSearch={true}
                        />
                        <XOKButton
                            style={{ width: '60px' }}
                            label='查询'
                            onClick={this._searchHandle}
                        />
                        <XCancelButton
                            style={{ marginLeft: '20px', width: '60px' }}
                            label='重置'
                            onClick={this._resetHandle}
                        />
                    </div>
                    <ActivityDateTable tableAction={this._tableAction} paginationChange={this._paginationChange} renderData={cardcentreListDetail} />
                </div>
            </Modal >
        );
    }
}

ActivityDate.propTypes = {
    title: PropTypes.string,// 弹框标题
    data: PropTypes.object, //数据
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数

    getCardcentreListDetail: PropTypes.func,//明细列表数据(action)
    cardcentreListDetail: PropTypes.object,
    getCardcentreListState: PropTypes.func,//明细列表-状态(action)
    cardcentreListState: PropTypes.array,

    history: PropTypes.object, // 路由history对象

};

const mapStateToProps = (state) => ({
    cardcentreListDetail: state.cardcentre.cardcentreListDetail,//明细列表数据
    cardcentreListState: state.cardcentre.cardcentreListState,//明细列表-状态
});

export default connect(mapStateToProps, { ...model.actions })(ActivityDate);